import { useState, useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";

export default function TelehealthCounselingForm({
  patient,
  sigPad,
  signature,
  signedBy,
  relationship,
  viewOnly,
  date,
}) {

  useEffect(() => {
    if (viewOnly) {
      sigPad.current.fromData(signature);
    }
  }, [viewOnly]);

  return (
    <div className="rounded-lg overflow-hidden">
      <div className="p-6 max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-center mb-6">
          Telehealth Counseling Consent Form
        </h1>

        <div className="space-y-5 mb-6">
          <div>
            <h3 className="font-medium">1. Telehealth Counseling</h3>
            <p className="text-gray-800">
              Telehealth counseling allows therapists, clinicians and
              specialists to provide a diagnosis, consultation and treatment
              using videoconference technology via telephone or computer.
            </p>
          </div>
          <div>
            <h3 className="font-medium">2. Purpose</h3>
            <p className="text-gray-800">
              The purpose of Telehealth Counseling Consent Form is to get
              permissions from patients in order to participate into telehealth
              counseling services.
            </p>
          </div>
          <div>
            <h3 className="font-medium">3. Confidentiality</h3>
            <p className="text-gray-800">
              Audio and video recordings of patients during appointments/online
              visits will be kept private. Medical and personal information of
              patients are protected by the state and governmental laws.
            </p>
          </div>
          <div>
            <h3 className="font-medium">4. Risks and Benefits</h3>
            <p className="text-gray-800">
              Telehealth counseling aims to provide a complete treatment to
              patients. It is considered and supported by researches that online
              counseling is an effective way in treatment of various disorders,
              personal issues and problems. On the other hand, it may not be
              beneficial and there is no guarantee that the counseling will be
              effective for patients.
            </p>
          </div>
          <div>
            <h3 className="font-medium">5. Payment</h3>
            <p className="text-gray-800">
              Patients agree that they are responsible for paying any additional
              cost or payment that their insurance providers do not cover.
            </p>
          </div>
          <div>
            <h3 className="font-medium">6. Rights</h3>
            <p className="text-gray-800">
              Patients can withdraw and withhold this consent at any time and
              they can end the treatment any time they would like to. Any action
              of patients will not affect the future treatment of or
              accessibility to counseling services.
            </p>
          </div>
          <div>
            <h3 className="font-medium">7. Consent</h3>
            <p className="text-gray-800">
              By signing this form, I agree that I know and understand the
              information above. My questions were answered completely during
              the discussion with the therapist, clinician or specialist. I
              hereby give my consent to participate into telehealth counseling
              services provided by the healthcare organization.
            </p>
          </div>
        </div>

        <div className="mb-4">
          <p className="block mb-1 text-gray-700">Patient Name:</p>
          <p className="border py-4 px-4 rounded-md text-sm">
            {`${patient.lastname} ${patient.firstname}`}
          </p>
        </div>

        <div className="mb-4">
          <p className="block mb-1 text-gray-700">Date:</p>
          <p className="border py-4 px-4 rounded-md text-sm">
            {viewOnly
              ? new Date(date).toLocaleDateString()
              : new Date().toLocaleDateString()}
          </p>
        </div>

        <div className="mb-4">
          <p className="block mb-1 text-gray-700">Signed By:</p>
          <p className="border py-4 px-4 rounded-md text-sm">
            {`${signedBy}`}
          </p>
        </div>
        <div className="mb-4">
          <p className="block mb-1 text-gray-700">Relationship with patient:</p>
          <p className="border py-4 px-4 rounded-md text-sm">
            {`${relationship}`}
          </p>
        </div>

        <div className="mb-4">
          <p className="block mb-1 text-gray-700">Signature:</p>
          <div className="border rounded-md p-2">
            <SignatureCanvas
              ref={sigPad}
              canvasProps={{
                className: `signature-canvas w-full h-40 bg-white ${
                  viewOnly ? "pointer-events-none" : ""
                }`,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
